module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Hello")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26ebb029"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index.vue
// module id = 192
// module chunks = 0